import React from "react";
import { Stack, Typography, Button } from "@mui/material";
import CodeVerification from "../inputs/CodeVerificationInput";
export interface RecoverPasswordFormInterface {
  handleAction: (type: string, data?: any) => void;
}

const RecoverPasswordForm = ({
  handleAction,
}: RecoverPasswordFormInterface) => {
  const [loading, setLoading] = React.useState(false);
  const [code, setCode] = React.useState("");
  return (
    <Stack
      alignItems="center"
      justifyContent="space-between"
      width="100%"
      height="100%"
    >
      <Stack padding={2} spacing={1.5} textAlign="center">
        <Typography variant="h1" fontWeight={700}>
          Verify your phone
        </Typography>
        <Typography variant="h4" fontWeight={400}>
          We’ve sent a code to the phone number you’ve added. Enter the code
          below.
        </Typography>
      </Stack>

      <Stack width="100%" alignItems="center" spacing={2}>
        <CodeVerification
          length={6}
          label="Enter Code"
          loading={loading}
          onComplete={(newCode: any) => {
            setCode(newCode);
            setLoading(true);
            setTimeout(() => setLoading(false), 10000);
          }}
        />
        <Button
          variant="text"
          sx={{
            color: "#B1D238",
            alignSelf: "flex-end",
            width: "fit-content",
            fontSize: 14,
            padding: "0!important",
          }}
          onClick={() => handleAction("resend-code")}
        >
          Resend Code
        </Button>
      </Stack>
      <Stack
        spacing={5}
        width="100%"
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Button
          variant="text"
          sx={{ color: "#000", width: "fit-content" }}
          fullWidth
          onClick={() => handleAction("handleBack")}
        >
          Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleAction("submit", code)}
        >
          Confirm Code
        </Button>
      </Stack>
    </Stack>
  );
};
export default RecoverPasswordForm;
